import { createApp } from 'vue'
import App from './App.vue'

const appElement = document.getElementById('essenza-product-app');

if( appElement ) {
    const product = JSON.parse(appElement.dataset.product);
    const defaultVariation = JSON.parse(appElement.dataset.defaultVariation);
    const variations = JSON.parse(appElement.dataset.variations);
    const attributes = JSON.parse(appElement.dataset.attributes);
    const isVariable = appElement.dataset.isVariable === '1';

    createApp(App, {
        product: product,
        defaultVariation: defaultVariation,
        variations: variations,
        attributes: attributes,
        isVariable: isVariable
    }).mount('#essenza-product-app')
} 
